import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';
import style from './style.module.less';

export const ImportStatusError = () => {
  return (
    <div className={style['import-status-error']}>
      <FormattedMessage {...messages.errorStatus} />
    </div>
  );
};
